import type React from 'react';
import { Text, Box, Stack, Button, Inline } from 'braid-design-system';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';

interface DeleteConfirmationProps {
  onDelete: () => void;
  onCancel: () => void;
  children: React.ReactNode;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  onDelete,
  onCancel,
  children,
}: DeleteConfirmationProps) => {
  const { t } = useTranslations(translations);
  return (
    <Box
      padding="medium"
      background="surface"
      boxShadow="borderNeutralLight"
      borderRadius="standard"
      width="full"
    >
      <Stack space="medium">
        <Text align="center">{children}</Text>
        <Inline space="xsmall" align="center">
          <Button onClick={onDelete}>{t('Delete')}</Button>
          <Button variant="transparent" onClick={onCancel}>
            {t('Cancel')}
          </Button>
        </Inline>
      </Stack>
    </Box>
  );
};

export default DeleteConfirmation;
